import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation,useHistory } from 'react-router-dom';
import {
  Box, List, ListItemButton, ListItemIcon,
  ListItemText, Collapse, Tooltip, Avatar,
  Typography, Divider, useTheme, useMediaQuery,
  CircularProgress, IconButton,Badge,Button
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import LogoutIcon from '@mui/icons-material/Logout';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CircleIcon from '@mui/icons-material/Circle';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'; 
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'; 
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'; 
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'; 
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'; 

import Drawer from './ManagedModal';

// IMPORT ICON CHO NÚT THU GỌN/MỞ RỘNG
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import NotificationIcon from "@mui/icons-material/Notifications"

import AuthContext from "./auth/Context";
import NotifitionContext from "./auth/NotificationContext";
import CounterWidget from './Counter'; 

const mobileDrawerWidth = 280;
const desktopPanel1ExpandedWidth = 260; 
const desktopPanel1CollapsedWidth = 88; 
const desktopPanel2Width = 250;         



// ===================== HÀM LẤY ICON =====================
const getItemIcon = (item) => {
  let type = item.type;
  const path = item.path || "";

  if (!type) {
    if (path.includes("/dashboard")) type = "dashboard";
    else if (path.includes("customer") || path.includes("khachhang") || path.includes("kh")) type = "customer";
    else if (path.includes("product") || path.includes("sanpham") || path.includes("bds") || path.includes("nhadat")) type = "product";
    else if (path.includes("user") || path.includes("nhanvien") || path.includes("participant")) type = "user";
    else if (path.includes("management") || path.includes("quanly") || path.includes("system") || path.includes("config")) type = "management";
    else if (path.includes("timeline") || path.includes("grantt") || path.includes("schedule")) type = "timeline";
    else if (path.includes("task") || path.includes("congviec") || path.includes("banlamviec")) type = "task";
    else if (path.includes("file") || path.includes("folder")) type = "file";
    else if (path.includes("/calc") || path.includes("/tinh")) type = "calc";
    else if (path.includes("/report")) type = "report";
    else if (path.includes("/list")) type = "list";
    else if (
      path.includes("/receipt") || path.includes("/invoice") || path.includes("/voucher") || 
      path.includes("/order") || path.includes("/contract") || path.includes("/hd") || 
      path.includes("/pn") || path.includes("/bc") || path.includes("/bn") || 
      path.includes("/pt") || path.includes("/pc") || path.includes("/pkt") || 
      path.includes("/pkc") || path.includes("/ppb")
    ) type = "receipt";
    else if (path.includes("khuyenmai") || path.includes("chietkhau")) type = "voucher";
    else type = "default";
  }

  const iconProps = { fontSize: "small", sx: { opacity: 0.7 } };

  switch (type) {
    case "dashboard": return <DashboardOutlinedIcon {...iconProps} />;
    case "file": return <InsertDriveFileOutlinedIcon {...iconProps} />;
    case "user": return <PersonOutlineIcon {...iconProps} />;
    case "customer": return <PeopleOutlineIcon {...iconProps} />;
    case "product": return <Inventory2OutlinedIcon {...iconProps} />;
    case "management": return <SettingsOutlinedIcon {...iconProps} />;
    case "calc": return <CalculateOutlinedIcon {...iconProps} />;
    case "voucher": return <CardGiftcardOutlinedIcon {...iconProps} />;
    case "report": return <BarChartOutlinedIcon {...iconProps} />;
    case "list": return <FormatListBulletedIcon {...iconProps} />;
    case "receipt": return <ReceiptOutlinedIcon {...iconProps} />;
    case "task": return <AssignmentOutlinedIcon {...iconProps} />;
    case "timeline": return <TimelineOutlinedIcon {...iconProps} />;
    default: return <CircleIcon sx={{ fontSize: '6px', opacity: 0.4, ml: 1 }} />;
  }
};

const DynamicModuleIcon = ({ module, active = false }) => {
  const { config } = useContext(AuthContext);
  const serverUrl = config?.server_url || "";
  let imgSrc = null;
  if (module.icon) {
    imgSrc = module.icon.startsWith("/getfile/") ? `${serverUrl}${module.icon}` : module.icon;
  }

  const commonStyles = { width: 28, height: 28, borderRadius: '6px' };

  if (imgSrc) {
    return (
      <Box 
        component="img" src={imgSrc} alt={module.title} 
        sx={{ 
          ...commonStyles, objectFit: 'contain',
          filter: active 
            ? 'brightness(0) invert(1)' 
            //: 'grayscale(100%) opacity(0.7) contrast(1.2)',
            :undefined,
          transition: 'all 0.3s ease',
        }} 
      />
    );
  }
  return (
    <Avatar 
      variant="rounded" 
      sx={{ 
        ...commonStyles, 
        fontSize: 14, 
        fontWeight: 'bold', 
        bgcolor: active ? 'rgba(255, 255, 255, 0.3)' : 'primary.main', 
        color: active ? '#ffffff' : 'primary.contrastText',
        border: '1px solid', 
        borderColor: active ? 'rgba(255, 255, 255, 0.5)' : 'divider' 
      }}
    >
      {module.title ? module.title.charAt(0).toUpperCase() : '?'}
    </Avatar>
  );
};

export const getValidItems = (items = [],context) =>{
  return items.filter(item=>item.visible!==false && (item.view || item.view_all) && (!item.system || context?.userInfo?.admin));
}

// ===================== THÀNH PHẦN CHÍNH =====================
const SidebarMenu = ({ menuData, mobileOpen, handleDrawerToggle }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const context = useContext(AuthContext);
  const {appInfo,config} = context;
  const [mobileOpenModules, setMobileOpenModules] = useState({});
  const [activeDesktopModule, setActiveDesktopModule] = useState(null);
  const history = useHistory();
  const notificationContext = useContext(NotifitionContext);
  
  // [THÊM] State để quyết định khi nào thì có animation, khi nào thì không (load tức thì)
  const [enableTransition, setEnableTransition] = useState(false);

 

  const [collapsedGroups, setCollapsedGroups] = useState(() => {
    const initialState = {};
    menuData.forEach(module => {
        //const validItems = (module.items || []).filter(item => item.visible !== false);
        const validItems = getValidItems(module.items || [],context);
        const grouped = validItems.reduce((acc, item) => {
            const groupName = item.group || 'Chung';
            acc[groupName] = true;
            return acc;
        }, {});
        //Luôn mở group đầu tiên
        Object.keys(grouped).forEach((gName,index) => {
            initialState[`${module.code}-${gName}`] = index!=0;
        });
    });
    return initialState;
  });

  const toggleGroup = (groupId) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };


  

  const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(false);

  // Hàm custom để vừa set state, vừa lưu xuống trình duyệt để nhớ cho lần sau
  const updateDesktopCollapsed = (collapsedState) => {
    setIsDesktopCollapsed(collapsedState);
  };

  const groupItemsByGroup = (validItems) => {
    return validItems.reduce((acc, item) => {
      const groupName = item.group || 'Chung';
      if (!acc[groupName]) acc[groupName] = [];
      acc[groupName].push(item);
      return acc;
    }, {});
  };

  useEffect(() => {
    if (isMobile) return;
    let foundModule = null;
    for (const module of menuData) {
      const validItems = getValidItems(module.items,context);
      if (validItems.some(item => item.path === location.pathname) && validItems.length > 1) {
        foundModule = module.code;
        // --- THÊM LOGIC MỚI: Tự động mở Group chứa trang hiện hành ---
        const grouped = groupItemsByGroup(validItems);
        Object.entries(grouped).forEach(([groupName, items]) => {
          if (items.some(item => item.path === location.pathname)) {
            const groupId = `${module.code}-${groupName}`;
            setCollapsedGroups(prev => ({ ...prev, [groupId]: false })); // Đảm bảo luôn mở
          }
        });
        // -------------------------------------------------------------
        break;
      }
    }
    // Chú ý: Ở đây ta KHÔNG gọi setEnableTransition(true). 
    // Vì thế khi reload hoặc vào page khác, menu bung ra lập tức không có hiệu ứng trượt
    if (foundModule) setActiveDesktopModule(foundModule);
  }, [location.pathname, menuData, isMobile]);




  const handleMobileToggle = (moduleCode) => {
    setMobileOpenModules((prev) => ({ ...prev, [moduleCode]: !prev[moduleCode] }));
  };

  const handleDesktopModuleClick = (moduleCode, itemCount) => {
    setEnableTransition(true); // [THÊM] Cho phép chạy hiệu ứng khi người dùng tự click thủ công

    if (itemCount > 1) {
      setActiveDesktopModule(prev => prev === moduleCode ? null : moduleCode);
    } else {
      setActiveDesktopModule(null);
      //updateDesktopCollapsed(true);
    }
  };


  const changeApp = ()=>{
    context.changeApp();
  }
  const signout = async()=>{
    await context.signout();
    history.replace("/");
  }
  const renderAppLogo = (size) => {
    // 1. Nếu có logo từ server
    if (appInfo?.logo) {
      return (
        <Tooltip title={appInfo.name}>
          <Box 
            component="img" 
            src={`${config?.server_url || ''}${appInfo.logo}`} 
            sx={{ maxHeight: size, maxWidth: '100%', objectFit: 'contain' }} 
          />
        </Tooltip>
        
      );
    }
    
    // 2. Fallback: Tạo logo mặc định từ chữ cái đầu của tên App
    const firstLetter = appInfo?.name ? appInfo.name.charAt(0).toUpperCase() : 'A';
    return (
      <Avatar 
        variant="rounded" 
        sx={{ 
          width: size, 
          height: size, 
          bgcolor: 'primary.main', // Dùng màu chính của App
          color: 'primary.contrastText', // Chữ trắng để nổi bật
          fontWeight: 900, 
          fontSize: size * 0.55, // Cỡ chữ tự động tỷ lệ với khung hình
          borderRadius: '10px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)' // Đổ bóng nhẹ cho đẹp
        }}
      >
        {firstLetter}
      </Avatar>
    );
  };
  // ================= RENDER COUNTER (BỘ ĐẾM) =================
  const renderItemCounter = (item) => {
    const targetCode = item.counterConfig?.code || item.code;
    const path = item.path || "";
    
    const isAllowedPath = path.includes("/list") || path.includes("/voucher") || path.includes("/receipt");
    
    if (!item.counterConfig && !isAllowedPath) return null;
    if (!targetCode || targetCode === "home" || targetCode === "dashboard" || targetCode === "system") return null;

    const extraProps = item.counterConfig || {};

    return (
      <CounterWidget
        code={targetCode}
        condition={item.counterConfig?.condition || {}}
        {...extraProps}
        renderRunning={() => (
          <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 1 }}>
            <CircularProgress size={14} color="inherit" sx={{ opacity: 0.5 }} />
          </Box>
        )}
        render={(number) => {
          if (number && number > 0) {
            return (
              <Box sx={{ ml: 'auto', bgcolor: 'error.main', color: 'white', borderRadius: '10px', px: 0.8, py: 0.25, fontSize: '0.7rem', fontWeight: 'bold', lineHeight: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '20px', boxShadow: '0 2px 4px rgba(211, 47, 47, 0.2)' }}>
                {number > 99 ? '99+' : number}
              </Box>
            );
          }
          return null;
        }}
      />
    );
  };

  // ===================== RENDER MENU MOBILE =====================
  const renderMobileContent = () => (
    <Box sx={{height:"100%",display: 'flex', flexDirection: 'column'}}>
      <Box sx={{pt: 'env(safe-area-inset-top)'}}></Box>
      <Box 
        component={Link} 
        to="/system/appinfo"
        onClick={handleDrawerToggle} // Đóng menu mobile sau khi click
        sx={{ 
          p: 2, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 1,
          textDecoration: 'none', // Bỏ gạch chân mặc định của thẻ link
          cursor: 'pointer',
          transition: 'opacity 0.2s',
          '&:hover': { opacity: 0.7 }, // Hiệu ứng mờ đi một chút khi đưa chuột vào
        }}
      >
        {renderAppLogo(48)}
        <Typography variant="h6" fontWeight="bold" color="primary" align="center" sx={{ fontSize: '1rem' }}>
          {context.appInfo?.name || "App Title"}
        </Typography>
      </Box>
      <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",pb:2}}><Button variant="text" color="warning"
        onClick={() => changeApp && changeApp()} 
      >
        Đổi công ty
      </Button></Box>
      <Divider />
      <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
        <List component="nav" disablePadding>
          {menuData.map((module) => {
            const validItems = getValidItems(module.items,context);
            if (validItems.length === 0) return null;

            if (validItems.length === 1) {
              const singleItem = validItems[0];
              const isActive = location.pathname === singleItem.path;
              return (
                <ListItemButton key={module.code} component={Link} to={singleItem.path || '#'} selected={isActive} onClick={handleDrawerToggle} sx={{ py: 1.2, px: 2, borderRadius: '12px', mx: 1, mb: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 48 }}><DynamicModuleIcon module={module} active={isActive} /></ListItemIcon>
                  <ListItemText 
                    primary={singleItem.title || module.title}
                    slotProps={{
                      primary:{ fontWeight: 500, fontSize: '0.925rem', color: 'text.primary' }
                    }}
                  />
                  {renderItemCounter(singleItem)}
                </ListItemButton>
              );
            }

            const isModuleOpen = mobileOpenModules[module.code];
            const grouped = groupItemsByGroup(validItems);
            const hasMultipleGroups = Object.keys(grouped).length > 1;

            return (
              <React.Fragment key={module.code}>
                <ListItemButton onClick={() => handleMobileToggle(module.code)} sx={{ py: 1.2, px: 2, borderRadius: '12px', mx: 1, mb: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 48 }}><DynamicModuleIcon module={module} /></ListItemIcon>
                  <ListItemText 
                    primary={module.title}
                    slotProps={{
                      primary:{ fontWeight: 500, fontSize: '0.925rem', color: 'text.primary' }
                    }}
                  />
                  {isModuleOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={isModuleOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>

                    {Object.entries(grouped).map(([groupName, items]) => {
                      const groupId = `${module.code}-${groupName}`;
                      const isGroupCollapsed = collapsedGroups[groupId];

                      return (
                        <React.Fragment key={groupName}>
                          
                          {/* ================= GIAO DIỆN GROUP CÓ THỂ BẤM (TOGGLE) ================= */}
                          {hasMultipleGroups && (
                            <ListItemButton 
                              onClick={() => toggleGroup(groupId)}
                              disableRipple
                              sx={{ 
                                    mt: 1.5, mb: 0.5, mx: 1.5, py: 0.5, 
                                    pl: 4, // [TĂNG THỤT LỀ MOBILE] Level 1: Group name thụt lề so với Module
                                    borderRadius: '8px',
                                    '&:hover': { bgcolor: 'action.hover' } 
                              }}
                            >
                              <Box 
                                sx={{ 
                                  display: 'inline-flex', alignItems: 'center', gap: 1,
                                  px: 1.2, py: 0.5, 
                                  bgcolor: (theme) => `${theme.palette.primary.main}15`, 
                                  borderRadius: '6px'
                                }}
                              >
                                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'primary.main' }} />
                                <Typography 
                                  sx={{ 
                                    fontSize: '0.65rem', fontWeight: 800, textTransform: 'uppercase', 
                                    letterSpacing: '0.08em', color: 'primary.main' 
                                  }}
                                >
                                  {groupName}
                                </Typography>
                              </Box>
                              
                              {/* Đường gạch ngang linh hoạt & Icon Expand */}
                              <Box sx={{ flex: 1, height: '1px', bgcolor: 'divider', mx: 1.5, opacity: 0.5 }} />
                              {isGroupCollapsed ? (
                                <ExpandMore sx={{ fontSize: 18, color: 'text.secondary', opacity: 0.7 }} />
                              ) : (
                                <ExpandLess sx={{ fontSize: 18, color: 'text.secondary', opacity: 0.7 }} />
                              )}
                            </ListItemButton>
                          )}
                          
                          {/* ================= VÙNG COLLAPSE BỌC CÁC ITEM ================= */}
                          <Collapse in={hasMultipleGroups ? !isGroupCollapsed : true} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {items.map((item) => {
                                const isActive = location.pathname === item.path;
                                return (
                                  <ListItemButton 
                                        key={item.code} 
                                        component={Link} 
                                        to={item.path} 
                                        selected={isActive} 
                                        onClick={handleDrawerToggle} 
                                        sx={{ 
                                            pl: 7, // [TĂNG THỤT LỀ MOBILE]
                                            pr: 2, 
                                            py: 0.75, 
                                            mb: 0.5, 
                                            mr: 2, 
                                            borderRadius: '0 20px 20px 0', 
                                            '&.Mui-selected': { bgcolor: 'primary.light', color: 'primary.contrastText' } 
                                        }}
                                        >
                                        <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>{getItemIcon(item)}</ListItemIcon>
                                        <ListItemText 
                                          primary={item.title}
                                          slotProps={{
                                            primary:{ variant: 'body2' }
                                          }}
                                        />
                                    </ListItemButton>
                                );
                              })}
                            </List>
                          </Collapse>

                        </React.Fragment>
                      );
                    })}

                  </List>
                </Collapse>
              </React.Fragment>
            );
          })}
        </List>
      </Box>
    </Box>
  );

  // ===================== RENDER DUAL-PANEL CHO DESKTOP =====================
  
  const currentRouteModuleCode = menuData.find(m => 
    getValidItems(m.items,context).some(item => item.path === location.pathname)
  )?.code;

  const visuallySelectedModuleCode = activeDesktopModule || currentRouteModuleCode;
  const activeModuleData = menuData.find(m => m.code === activeDesktopModule);
  const notifications = notificationContext.notifications || 0;
  
  const renderDesktopContent = () => {
    return (
      <Box sx={{ display: 'flex', height: '100%', flexShrink: 0, zIndex: 1200 }}>
        
        {/* PANEL 1: DANH SÁCH MODULE CHÍNH */}
        <Box 
          sx={{ 
            width: isDesktopCollapsed ? desktopPanel1CollapsedWidth : desktopPanel1ExpandedWidth, 
            // [THÊM ĐIỀU KIỆN TẠI ĐÂY]
            transition: enableTransition ? 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)' : 'none', 
            borderRight: 1, borderColor: 'divider', 
            bgcolor: 'background.paper', display: 'flex', flexDirection: 'column', 
            overflowX: 'hidden', zIndex: 2
          }}
        >
          {/* LOGO SECTION (DESKTOP) */}
          <Box 
            component={Link}
            to="/system/appinfo"
            sx={{ 
              p: isDesktopCollapsed ? 1.5 : 2, 
              pt: isDesktopCollapsed ? 1 : 1.5, // Tăng thêm khoảng không phía trên một chút
              pb: isDesktopCollapsed ? 1 : 1,
              display: 'flex', 
              
              // [QUAN TRỌNG] Đổi thành Hàng ngang khi mở rộng, Hàng dọc khi thu nhỏ
              flexDirection: isDesktopCollapsed ? 'column' : 'row', 
              alignItems: 'center', 
              gap: isDesktopCollapsed ? 1 : 1.5, 
              //minHeight: 80, 
              justifyContent: isDesktopCollapsed ? 'center' : 'flex-start',
              textDecoration: 'none', 
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': { bgcolor: 'action.hover' }
            }}
          >
            {/* Tăng kích thước logo một chút khi mở rộng để cân xứng với text */}
            {renderAppLogo(isDesktopCollapsed ? 36 : 42)}

            {!isDesktopCollapsed && (
               <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                 <Typography 
                    variant="h6" 
                    fontWeight="bold" 
                    color="primary" 
                    sx={{ 
                      fontSize: '0.95rem', // Chỉnh size chữ vừa vặn
                      lineHeight: 1.3,     // Khoảng cách dòng thoáng mắt
                      whiteSpace: 'normal',// Cho phép rớt dòng
                      wordBreak: 'break-word', 
                      
                      // Hiệu ứng cắt chữ thông minh: Chỉ cho phép hiện tối đa 3 dòng, nếu dài hơn sẽ thêm dấu ...
                      display: '-webkit-box',
                      WebkitLineClamp: 3, 
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}
                 >
                   {appInfo?.name || "App Title"}
                 </Typography>
               </Box>
            )}
          </Box>
          {/*!isDesktopCollapsed && <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",pb:1}}><Button variant="text" color="warning"
            onClick={() => changeApp && changeApp()} 
          >
            Đổi công ty
          </Button></Box>*/}

          <Divider sx={{ mb: 1 }}/>
          
          <List sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden', px: isDesktopCollapsed ? 1 : 1.5 }}>
            {menuData.map((module) => {
              const validItems = getValidItems(module.items,context);
              if (validItems.length === 0) return null;
              
              const isSelected = visuallySelectedModuleCode === module.code;

              const buttonContent = (
                <ListItemButton 
                  component={validItems.length === 1 ? Link : 'div'}
                  to={validItems.length === 1 ? validItems[0].path : undefined}
                  onClick={() => handleDesktopModuleClick(module.code, validItems.length)}
                  selected={isSelected}
                  sx={{ 
                    py: 1.2, px: isDesktopCollapsed ? 0 : 1.5, 
                    borderRadius: '12px', mb: 1,
                    justifyContent: isDesktopCollapsed ? 'center' : 'flex-start',
                    '&.Mui-selected': {
                      bgcolor: 'primary.main', 
                      color: 'primary.contrastText',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      '&:hover': { bgcolor: 'primary.dark' },
                      '& .MuiListItemIcon-root': { color: 'inherit' }
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 'auto', mr: isDesktopCollapsed ? 0 : 2, display: 'flex', justifyContent: 'center', color: 'inherit' }}>
                    <DynamicModuleIcon module={module} active={isSelected} />
                  </ListItemIcon>
                  
                  {!isDesktopCollapsed && (
                    <ListItemText 
                      primary={validItems.length === 1?validItems[0].title:module.title}
                      slotProps={{
                        primary:{ 
                          fontWeight: 500,     // Giảm độ đậm từ 600 xuống 500
                          fontSize: '0.925rem', 
                          lineHeight: 1.3,     // Thêm khoảng cách giữa các dòng để chữ không bị dính vào nhau
                          color: 'inherit',
                          sx: {
                            whiteSpace: 'normal',    // Cho phép rớt dòng
                            wordBreak: 'break-word', // Ép rớt dòng nếu có 1 từ viết liền quá dài
                            paddingRight: 1          // Cách lề phải một chút để không dính sát vào mũi tên
                          }
                        }
                      }}
                    />
                  )}

                  {(!isDesktopCollapsed && validItems.length === 1) && renderItemCounter(validItems[0])}

                  {(!isDesktopCollapsed && validItems.length > 1) && (
                     <ExpandMore sx={{ fontSize: 18, opacity: 0.8, transform: 'rotate(-90deg)', color: 'inherit' }} /> 
                  )}
                </ListItemButton>
              );

              return isDesktopCollapsed ? (
                <Tooltip title={module.title} placement="right" arrow key={module.code}>
                  {buttonContent}
                </Tooltip>
              ) : (
                <React.Fragment key={module.code}>{buttonContent}</React.Fragment>
              );
            })}
          </List>


          {/* ========================================================= */}
          {/* KHU VỰC ĐÁY SIDEBAR (HỆ THỐNG & NÚT THU MỞ) */}
          {/* ========================================================= */}
          <Divider />
          <Box 
            sx={{ 
              p: 1.5, 
              display: 'flex', 
              // Đổi hướng: Thu nhỏ thì xếp dọc (column), Mở rộng thì xếp ngang (row)
              flexDirection: isDesktopCollapsed ? 'column' : 'row', 
              alignItems: 'center', 
              justifyContent: isDesktopCollapsed ? 'center' : 'space-between',
              gap: isDesktopCollapsed ? 1 : 0
            }}
          >
            
            {/* NHÓM 3 NÚT HỆ THỐNG (NẰM BÊN TRÁI KHI MỞ RỘNG) */}
            <Box 
              sx={{ 
                display: 'flex', 
                flexDirection: isDesktopCollapsed ? 'column' : 'row',
                alignItems: 'center',
                gap: isDesktopCollapsed?1:1
              }}
            >

              {/* 1. Thông báo */}
              <Tooltip title="Thông báo" placement={isDesktopCollapsed ? "right" : "top"} arrow>
                <IconButton 
                  component={Link} to="/notifications" 
                  onClick={() => { 
                    if (typeof setEnableTransition === 'function') setEnableTransition(true); 
                    if (typeof updateDesktopCollapsed === 'function') updateDesktopCollapsed(true);
                  }}
                  sx={{ bgcolor: 'action.hover', color: 'text.secondary', width: 36, height: 36 }}
                >
                  <Badge badgeContent={notifications||0}  color="error">
                    <NotificationIcon fontSize="small" />
                  </Badge>
                </IconButton>
              </Tooltip>
              
              {/* 1. Nút Trang cá nhân */}
              <Tooltip title="Trang cá nhân" placement={isDesktopCollapsed ? "right" : "top"} arrow>
                <IconButton 
                  component={Link} to="/profile" 
                  onClick={() => { 
                    if (typeof setEnableTransition === 'function') setEnableTransition(true); 
                    if (typeof updateDesktopCollapsed === 'function') updateDesktopCollapsed(true);
                  }}
                  sx={{ bgcolor: 'action.hover', color: 'text.secondary', width: 36, height: 36 }}
                >
                  <PersonOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              

              {/* 2. Nút Đổi công ty */}
              <Tooltip title="Đổi công ty" placement={isDesktopCollapsed ? "right" : "top"} arrow>
                <IconButton 
                  onClick={() => changeApp && changeApp()} 
                  sx={{ bgcolor: 'action.hover', color: 'text.secondary', width: 36, height: 36 }}
                >
                  <SyncAltIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              {/* 3. Nút Đăng xuất */}
              {!isDesktopCollapsed && <Tooltip title="Đăng xuất" placement={isDesktopCollapsed ? "right" : "top"} arrow>
                <IconButton 
                  onClick={() => signout && signout()} 
                  sx={{ 
                    bgcolor: (theme) => `${theme.palette.error.main}15`, // Nền đỏ siêu nhạt
                    color: 'error.main', 
                    width: 36, height: 36,
                    '&:hover': { bgcolor: 'error.main', color: 'white' } // Hover vào thì đỏ rực
                  }}
                >
                  <LogoutIcon fontSize="small" />
                </IconButton>
              </Tooltip>}
            </Box>

            {/* Vạch ngăn cách (Chỉ hiện khi thu gọn để chia tách nút hệ thống và nút Toggle) */}
            {isDesktopCollapsed && <Divider sx={{ width: '100%', my: 0.5 }} />}

            {/* NÚT TOGGLE (NẰM BÊN PHẢI KHI MỞ RỘNG) */}
            <Tooltip title={isDesktopCollapsed ? "Mở rộng" : "Thu gọn"} placement={isDesktopCollapsed ? "right" : "top"} arrow>
              <IconButton 
                onClick={() => { 
                  if (typeof setEnableTransition === 'function') setEnableTransition(true); 
                  if (typeof updateDesktopCollapsed === 'function') updateDesktopCollapsed(!isDesktopCollapsed); 
                }} 
                sx={{ 
                  bgcolor: 'action.hover', 
                  color: 'text.secondary',
                  width: 36, height: 36
                }}
              >
                {isDesktopCollapsed ? <KeyboardDoubleArrowRightIcon fontSize="small" /> : <KeyboardDoubleArrowLeftIcon fontSize="small" />}
              </IconButton>
            </Tooltip>

          </Box>

        </Box>

        {/* PANEL 2: DANH SÁCH MENU CON CỦA MODULE */}
        <Box 
          sx={{ 
            width: !!activeDesktopModule ? desktopPanel2Width : 0, 
            // [THÊM ĐIỀU KIỆN TẠI ĐÂY]
            transition: enableTransition ? 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)' : 'none', 
            bgcolor: '#f8f9fa', 
            borderRight: !!activeDesktopModule ? 1 : 0, borderColor: 'divider',
            overflow: 'hidden', display: 'flex', flexDirection: 'column'
          }}
        >
          {activeModuleData && (
            <Box sx={{ width: desktopPanel2Width, display: 'flex', flexDirection: 'column', height: '100%' }}>
              <Box sx={{ p: 2.5, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ fontSize: '1.1rem' }}>
                  {activeModuleData.title}
                </Typography>
                
                {/* NÚT THU GỌN PANEL 2 */}
                <Tooltip title="Thu gọn" placement="right" arrow>
                  <IconButton 
                    onClick={() => {
                      if (typeof setEnableTransition === 'function') setEnableTransition(true);
                      setActiveDesktopModule(null); // Set null để Panel 2 trượt đóng lại
                    }}
                    sx={{ 
                      bgcolor: 'action.hover', 
                      color: 'text.secondary',
                      width: 32, height: 32
                    }}
                  >
                    <KeyboardDoubleArrowLeftIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Divider />
              
              <List sx={{ flexGrow: 1, overflowY: 'auto', py: 2 }}>
                {(() => {
                  const grouped = groupItemsByGroup(getValidItems(activeModuleData.items,context));
                  const hasMultipleGroups = Object.keys(grouped).length > 1;

                  return Object.entries(grouped).map(([groupName, items]) => {
                      const groupId = `${activeModuleData.code}-${groupName}`;
                      const isGroupCollapsed = collapsedGroups[groupId];

                      return (
                        <React.Fragment key={groupName}>
                          
                          {/* ================= GIAO DIỆN GROUP CÓ THỂ BẤM (TOGGLE) ================= */}
                          {hasMultipleGroups && (
                            <ListItemButton 
                              onClick={() => toggleGroup(groupId)}
                              disableRipple
                              sx={{ 
                                mt: 1.5, mb: 0.5, mx: 1.5, py: 0.5, px: 1, 
                                borderRadius: '8px',
                                '&:hover': { bgcolor: 'action.hover' } // Hover nhẹ nhàng
                              }}
                            >
                              <Box 
                                sx={{ 
                                  display: 'inline-flex', alignItems: 'center', gap: 1,
                                  px: 1.2, py: 0.5, 
                                  bgcolor: (theme) => `${theme.palette.primary.main}15`, 
                                  borderRadius: '6px'
                                }}
                              >
                                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'primary.main' }} />
                                <Typography 
                                  sx={{ 
                                    fontSize: '0.65rem', fontWeight: 800, textTransform: 'uppercase', 
                                    letterSpacing: '0.08em', color: 'primary.main' 
                                  }}
                                >
                                  {groupName}
                                </Typography>
                              </Box>
                              
                              {/* Đường gạch ngang linh hoạt & Icon Expand */}
                              <Box sx={{ flex: 1, height: '1px', bgcolor: 'divider', mx: 1.5, opacity: 0.5 }} />
                              {isGroupCollapsed ? (
                                <ExpandMore sx={{ fontSize: 18, color: 'text.secondary', opacity: 0.7 }} />
                              ) : (
                                <ExpandLess sx={{ fontSize: 18, color: 'text.secondary', opacity: 0.7 }} />
                              )}
                            </ListItemButton>
                          )}
                          
                          {/* ================= VÙNG COLLAPSE BỌC CÁC ITEM ================= */}
                          <Collapse in={hasMultipleGroups ? !isGroupCollapsed : true} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {items.map((item) => {
                                const isActive = location.pathname === item.path;
                                return (
                                  <ListItemButton 
                                    key={item.code} component={Link} to={item.path} 
                                    onClick={() =>{
                                      if (typeof setEnableTransition === 'function') setEnableTransition(true); 
                                      if (typeof updateDesktopCollapsed === 'function') updateDesktopCollapsed(true);
                                      if (isMobile && typeof handleDrawerToggle === 'function') handleDrawerToggle();
                                    }}
                                    selected={isActive} 
                                    sx={{ 
                                      pl: 4, pr: 2, py: 0.8, mb: 0.5, mr: 2, borderRadius: '0 20px 20px 0', 
                                      '&.Mui-selected': { bgcolor: 'primary.light', color: 'primary.contrastText', '& .MuiListItemIcon-root': { color: 'inherit' }, '& svg': { opacity: 1 } } 
                                    }}
                                  >
                                    <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>{getItemIcon(item)}</ListItemIcon>
                                    <ListItemText 
                                      primary={item.title} sx={{ pr: 1 }}
                                      slotProps={{
                                        primary:{ variant: 'body2', fontWeight: isActive ? 600 : 400, color: isActive ? 'inherit' : 'text.secondary' }
                                      }}
                                    />
                                    {renderItemCounter(item)}
                                  </ListItemButton>
                                );
                              })}
                            </List>
                          </Collapse>

                        </React.Fragment>
                      );
                    })
                  
                })()}
              </List>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box component="nav">
      <Drawer type="drawer" variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: mobileDrawerWidth, boxSizing: 'border-box' } }}>
        {renderMobileContent()}
      </Drawer>

      <Box sx={{ display: { xs: 'none', md: 'block' }, height: '100%' }}>
        {renderDesktopContent()}
      </Box>
    </Box>
  );
};

export default SidebarMenu;